// Shared date-display helper. The app stores/queries dates as ISO (yyyy-MM-dd) but
// displays them in US MM/DD/YYYY form (e.g. 2026-07-03 -> 07/03/2026).
//
// Only use this for DISPLAY. Never feed the result back into a `type="date"` input,
// a query param, or a download filename — those must stay ISO.

const pad = (n) => String(n).padStart(2, '0');

/**
 * Format a backend date value as MM/DD/YYYY.
 * Accepts an ISO date/date-time string, a US M/d/yyyy string, or a Date.
 * Returns the input unchanged when it isn't a recognizable date (e.g. '', '—', null).
 */
export function formatDate(value) {
  if (value == null || value === '') return '';

  if (value instanceof Date) {
    return isNaN(value.getTime()) ? '' : `${pad(value.getMonth() + 1)}/${pad(value.getDate())}/${value.getFullYear()}`;
  }

  const s = String(value).trim();

  // ISO date or date-time: yyyy-MM-dd[...]. Parse the parts directly to avoid
  // timezone shifting a plain date to the previous day.
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[2]}/${iso[3]}/${iso[1]}`;

  // Already US-style M/d/yyyy or M-d-yyyy → normalize to zero-padded MM/DD/YYYY.
  const us = s.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})/);
  if (us) return `${pad(us[1])}/${pad(us[2])}/${us[3]}`;

  return s; // not a date we recognize — leave it as-is
}
